const MyClaimOverviewPageActionTypes = {
  LOAD_MY_CLAIM_OVERVIEW_START: 'LOAD_MY_CLAIM_OVERVIEW_START',
  LOAD_MY_CLAIM_OVERVIEW_END: 'LOAD_MY_CLAIM_OVERVIEW_END',
  CLEANUP_MY_CLAIM_OVERVIEW: 'CLEANUP_MY_CLAIM_OVERVIEW',
  TOGGLE_DELETE_CLAIM_DIALOG: 'TOGGLE_MY_CLAIM_OVERVIEW_DELETE_DIALOG'
};
export default MyClaimOverviewPageActionTypes;
